<template>
	<div class="myBiaoZhu" :id="'myBiaoZhuDiv' + idx || 0">
		<img :id="'myBiaoZhu' + idx || 0" :src="imgUrl" alt="" style="height: 100%; width: 100%" ref="direcrDel" />
	</div>
</template>
<script>
	export default {
		name: "",
		components: {},
		props: ["isBZ", "imgUrl", "idx"], // 是否可标注
		data() {
			return {
				canBiaoZhu: false, //是否可以进行标注
				pointSize: 16, //点的大小
				// pointColor: require('@/assets/img/crticon/smoke.png'), //点的颜色
				pointColor: "red", //点的颜色
				aditMark: "", // 待编辑的标点
				data: {}, // 位置数据以及内容
				banMa: [], //斑马线的数组
				pointList: [], //已存在的点
				directionStatus: true, // 方向状态
				directionnNum: "",
			};
		},
		methods: {
			edit() {
				if (this.canBiaoZhu) {
					this.endBiaoZhu();
				} else {
					this.startBiaoZhu();
				}
			},

			//开始标注
			startBiaoZhu(data) {
				if (data || this.aditMark) {
					var bz = true;
					if (data) {
						this.pointList.map((item) => {
							if (item == data.point_uuid) {
								var div = document.getElementById(item);
								this.editMarker(div);
								bz = false;
							}
						});
						if (bz) {
							this.data = data;
						}
						this.$message.info("请选择点位位置");
						this.canBiaoZhu = true;
					} else {
						// this.$message.info("请选择点位位置");
						// this.canBiaoZhu = true;
					}

					// if (bz) {
					//  this.$message.info('请选择点位位置')

					// }
				}

				// 如果有数据传来 则开始标注
				// {
				//       tag: item.number,
				//       tagName: `部位编号:${item.number}
				//               部位名称:${item.device_name}`,
				//       position: {
				//         x: item.x_axis,
				//         x1: item.xa_axis,
				//         y: item.y_axis,
				//         y1: item.ya_axis,
				//       },
				//       point_uuid: item.point_uuid,
				//     };
				// console.log(data)
				// if(data){
				//   data.map(item=>{
				//     this.getPoint(item.x,item.y,item.tagName)
				//   })
				// }
			},
			//完成标注
			endBiaoZhu() {
				//标注完成 关闭标注状态 重置当前标注的div以及数据
				this.canBiaoZhu = false;
				this.aditMark = null;

				this.data = [];
			},
			//画点
			createMarker(x, y, data, uuid, it, arrow_remark) {
				// log(x, y, uuid, it.arrow_remark, '画点');
				// 设置全局变量
				let _icon;
				if (!this.aditMark) {
					var div = document.createElement("div");

					div.className = "marker";

					div.id = uuid;
					div.arrow_remark = arrow_remark;
					this.banMa.push({
						id: this.banMa.length + 1,
						x,
						y,
					});
				} else {
					var div = this.aditMark;
				}
				y = y + document.getElementById("myBiaoZhu" + this.idx).offsetTop - this.pointSize / 2;
				x = x + document.getElementById("myBiaoZhu" + this.idx).offsetLeft - this.pointSize / 2;

				var systype = it ? it.type : this.data ? this.data.type : null;
				var icon = this.$map.crtIcon[systype];

				if (it && it.type == 280) {
					let iconType = it.type;

					switch (it.state) {
						case 1: // 闪动 应急开启
							iconType = it.type + "2";
							break;
						case 2: // 正常 绿色
							break;
						case 3: // 黄色 故障
							iconType = it.type + "1";
							break;
						default:
							// 灰色 关闭
							iconType = it.type + "3";
							break;
					}
					icon = this.$map.crtIcon[iconType];

					// console.log('error', it);
					let iconIcon = null;
					if (typeof it?.arrow_remark != "string") {
						it.arrow_remark = it?.arrow_remark
							.filter((d) => {
								return d;
							})
							.sort();
						iconIcon = icon[it.arrow_remark.join(",") || 7];
					} else {
						iconIcon = icon[it.arrow_remark || 7];
					}

					div.style.background = `url(${require(`../assets/img/crticon/${iconIcon ? iconIcon : "normal_escape.png"}`)})  50% 50% no-repeat`;
					div.style.borderRadius = "0";
					div.style.backgroundSize = "70% 70%";
					this.pointSize = 50;
				}
				if (icon == 226) {
					this.pointSize = 15;
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "comra.png"}`)})  50% 50% no-repeat`;
				}
				if (it && it.type == 226) {
					this.pointSize = 15;
					// 设置图标
					_icon = document.createElement("div");
					_icon.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "comra.png"}`)})  50% 50% no-repeat`;
					_icon.style.backgroundSize = "100% 100%";
					_icon.style.backgroundRepeat = "no-repeat";
					_icon.style.borderRadius = "0";
					_icon.style.zIndex = "555";
					_icon.style.height = "100%";
					_icon.style.width = "100%";
					// 根据right列表返回的arrow_remark 进行方向旋转
					// log(it.arrow_remark);
					let direcrionArrow = it.arrow_remark;
					_icon.style.transform = `rotate(${direcrionArrow * 22.5}deg)`;
					// 添加到div中
					div.appendChild(_icon);
				}
				if (icon == 243) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "point.png"}`)})  50% 50% no-repeat`;
				}
				if (it && it.type == 243) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "point.png"}`)})  50% 50% no-repeat`;
					div.style.backgroundSize = "100% 100%";
					div.style.backgroundRepeat = "no-repeat";
					// div.style.borderRadius = "0";
					this.pointSize = 15;
				}
				if (icon == 274) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "point.png"}`)})  50% 50% no-repeat`;
				}
				if (it && it.type == 274) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "point.png"}`)})  50% 50% no-repeat`;
					div.style.backgroundSize = "100% 100%";
					div.style.backgroundRepeat = "no-repeat";
					div.style.borderRadius = "0";
					this.pointSize = 15;
				}
				// 烟感
				if (it && it.type == 227) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "yangan.png"}`)})  50% 50% no-repeat`;
					div.style.backgroundSize = "100% 50%";
					div.style.backgroundRepeat = "no-repeat";
					// div.style.borderRadius = '0';
					this.pointSize = 18;
				}
				// 排风烟机
				if (it && it.type == 238) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "fan.png"}`)})  100% 100% no-repeat`;
					div.style.backgroundSize = "100% 80%";
					div.style.backgroundRepeat = "no-repeat";
					div.style.borderRadius = "0";
					div.style.zIndex = "88";
					this.pointSize = 40;
				}
				// 温感
				if (icon == 228) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "wengan.png"}`)})  50% 50% no-repeat`;
				}
				if (it && it.type == 228) {
					div.style.backgroundSize = "96% 60%";
					div.style.backgroundRepeat = "no-repeat";
					div.style.borderRadius = "0";
					this.pointSize = 15;
				}
				if (it && (it.type == 240 || it.type == 241)) {
					div.style.borderRadius = "0";
					div.style.width = "100px";
					div.style.height = "100px";
					div.style.backgroundSize = "100% 100%";
					div.style.backgroundRepeat = "no-repeat";
				} else {
					div.style.width = this.pointSize + 1 + "px";
					div.style.height = this.pointSize - 1 + "px";
				}
				if (icon === 229) {
					div.style.background = `url(${require(`../assets/img/crticon/${icon ? icon : "shoubao.jpg"}`)})  50% 50% no-repeat`;
				}
				if (it && it.type == 229) {
					div.style.backgroundSize = "100% 100%";
					div.style.backgroundRepeat = "no-repeat";
					div.style.borderRadius = "0";
					this.pointSize = 15;
				}

				div.style.left = x + "px";
				div.style.top = y + "px";

				if ((it && it.type == 226) || icon == 226) {
					if (!this.$route.meta.ishome) {
						// 监听到点击图标时...
						_icon.onclick = () => {
							const all_doms = document.getElementsByClassName("DirectionDialog");
							const all_doms_len = all_doms.length;
							for (let i = all_doms_len - 1; i >= 0; i--) {
								all_doms[i].remove();
							}

							// 创建圆饼弹框
							var camraDirection = document.createElement("div");
							camraDirection.className = "DirectionDialog";
							camraDirection.id = "DirectionDialog";
							camraDirection.style.left = -51 + "px";
							camraDirection.style.top = 20 + "px";
							camraDirection.style.width = 100 + "px";
							camraDirection.style.height = 100 + "px";
							camraDirection.style.background = "#eee";
							camraDirection.style.borderRadius = "50%";
							camraDirection.style.zIndex = "999";

							const pie = document.createElement("div");
							pie.className = "pie";
							pie.style.zIndex = "999";
							pie.id = "directionStatus";

							// 设置方向按钮 使用图片
							for (let i = 1; i <= 8; i++) {
								const tagA = document.createElement("p");
								tagA.className = `slice-${i} slice`;
								tagA.href = "javascript:;";
								const img = document.createElement("img");
								img.src = "https://static.thenounproject.com/png/105119-200.png";
								tagA.appendChild(img);

								tagA.onclick = function(e) {
									// console.log(e.currentTarget, 'click camera', _icon);
									_icon.style.transform = `rotate(${i * 22.5}deg)`;

									changeDirection(i, div.id, it.arrow_remark);
								};
								pie.appendChild(tagA);
							}
							// 关闭dictionDia
							let closeBtn = document.createElement("input");
							closeBtn.type = "button";
							closeBtn.value = "关闭";
							closeBtn.className = "closebtn";

							closeBtn.onclick = function(e) {
								camraDirection.remove();
								const all_doms = document.getElementsByClassName("texter");
								const all_doms_len = all_doms.length;
								for (let i = all_doms_len - 1; i >= 0; i--) {
									all_doms[i].style.display = "none";
								}
							};
							camraDirection.append(closeBtn);
							camraDirection.appendChild(pie);
							div.appendChild(camraDirection);

							const _this = this;
							window.changeDirection = function(number, id) {
								_this.nvrPreview(number, id);
							};
						};
					}
				}

				document.getElementById("myBiaoZhuDiv" + this.idx).appendChild(div);

				if (!this.aditMark) {
					var div2 = document.createElement("div");
					div2.className = "texter";
					div2.style.zIndex = "999";

					div2.style.left = -70 + "px";
					div2.style.bottom = 15 + "px";
					div2.style.width = 240 + "px";
					div2.style.background = "#eee";
					div2.style.borderRadius = "10px";
					div.appendChild(div2);

					div2.innerHTML = this.data.tagName ? this.data.tagName : data;
				}
				if (!this.canBiaoZhu) {
					div.onclick = () => {
						this.$emit("pointClick", it);
					};
				}
				// console.log(this.idx,'set marker');
				this.moveMark();
				this.endBiaoZhu();
			},
			// 方向
			nvrPreview(number, id, arrow_remark) {
				this.$post("/crt/crtArrowWebCam", { pointUuid: id, arrowRemark: number })
					.then((res) => {
						console.log(res);
						this.directionnNum = arrow_remark;
						return this.$message({
							message: "修改成功",
							type: "success",
							duration: 700,
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 获取标点的div
			getPoint(x, y, data, uuid, it) {
				// if(this.canBiaoZhu){
				// if(!it)return
				// // var _self = this;
				// _self = this?.idx;
				var myImg = document.querySelector("#myBiaoZhu" + this.idx);
				var currWidth = myImg.clientWidth;
				var currHeight = myImg.clientHeight;
				if (this.canBiaoZhu) {
					//如果是标注点位 则需要计算 百分比
					var ProportionWidthInImg = x / currWidth;
					var ProportionHeightInImg = y / currHeight;
					// console.log('图片比例高度：' + ProportionHeightInImg);
					// console.log('图片比例宽度：' + ProportionWidthInImg);
					// console.log(ProportionWidthInImg * 100 + "%");
					// console.log(ProportionHeightInImg * 100 + "%");
					var valobj = {
						x_axis: ProportionWidthInImg * 100 + "%",
						y_axis: ProportionHeightInImg * 100 + "%",
						xa_axis: "",
						ya_axis: "",
						point_uuid: this.data.point_uuid ? this.data.point_uuid : this.aditMark.id,
					};

					this.$emit("added", valobj);
					this.createMarker(x, y, null, valobj.point_uuid, it);
					uuid = valobj.point_uuid;
				} else {
					// 如果 不是 则不是手动标注 计算传来的百分比
					x = (Number(x.substring(0, x.lastIndexOf("%"))) / 100) * currWidth;
					y = (Number(y.substring(0, y.lastIndexOf("%"))) / 100) * currHeight;
					// console.log(x,y);
					this.createMarker(x, y, data, uuid, it);
				}
				this.pointList.push(uuid);

				// 隐藏点位信息
				setTimeout(() => {
					var divs = document.getElementsByClassName("texter");
					for (var i = 0; i < divs.length; i++) {
						divs[i].style.display = "none";
					}
				}, 20);
			},
			getBiaozhu(data, tabindex) {
				// 获取标注 先重置
				console.log(1);
				this.remove();
				// 地图上的所有坐标点位
				this.markers = data;
				// console.log(2);
				if (data.length) {
					// setTimeout(()=>{

					data.forEach((item) => {
						if (item.x && item.y) {
							this.getPoint(item.x, item.y, item.tagName, item.point_uuid, item);
						}
					});
					// },1000)
				}
				// 加载完后判断 取消显示点位信息
				// console.log(3);
				setTimeout(() => {
					var divs = document.getElementsByClassName("texter");
					for (var i = 0; i < divs.length; i++) {
						divs[i].style.display = "none";
					}
				}, 20);
				// console.log(4);
			},

			// 点击标点时 拖拽修改
			moveMark(Odiv) {
				let _this = this;
				// this.remove();
				var divs = document.getElementsByClassName("marker");
				for (var i = 0; i < divs.length; i++) {
					divs[i].ondblclick = function(e) {
						log(e);
						if (!_this.isBZ) {
							return;
						}
						//   // e.stopPropagation();
						//   // _this.editMarker(this);
					};
					//鼠标移入 当前点位时 显示当前点位的信息 （可能修改）
					divs[i].onmouseover = function(e) {
						// this.remove();
						e.target.style.zIndex = 99999;
						this.getElementsByClassName("texter")[0].style.display = "block";

						e.target.style.zIndex = 99999;
						this.getElementsByClassName("texter")[0].onmouseover = function() {
							e.target.style.zIndex = 99999;
						};
						this.getElementsByClassName("texter")[0].onmouseout = function() {};
					};
					divs[i].onmouseout = function(e) {
						this.getElementsByClassName("texter")[0].style.display = "none";
						e.target.style.zIndex = 9;
					};
				}
			},
			// 编辑当前的 标点 获取当前选中的div 删除重新标点
			editMarker(div) {
				this.aditMark = div;
				document.getElementById("myBiaoZhuDiv" + this.idx).removeChild(div);
				this.startBiaoZhu();
			},

			// 重置标点 清空所有内存变量
			remove() {
				// var divs = document.getElementsByClassName("marker");
				// var fatherdiv =  document.getElementById("myBiaoZhuDiv")
				// console.log(divs.length)
				// if(divs.length){
				//   for (var i = 0; i < divs.length-1; i++) {
				//     console.log(i)
				//   console.log(divs[i])
				// }
				// }
				// var child = document.getElementsByClassName("marker");
				// console.log("999999"+this.idx)
				const target = `#myBiaoZhuDiv${this.idx} .marker`;
				var child = document.querySelectorAll(target);
				if (child == null) {
					return;
				}
				child.removeNode = [];
				// console.log(child)
				if (child.length != undefined) {
					var len = child.length;
					for (var i = 0; i < len; i++) {
						child.removeNode.push({
							parent: child[i].parentNode,
							inner: child[i].outerHTML,
							next: child[i].nextSibling,
						});
					}
					// console.log(child[0])
					for (var i = 0; i < len; i++) {
						child[i].parentNode.removeChild(child[i]);
					}
				} else {
					child.removeNode.push({
						parent: child.parentNode,
						inner: child.outerHTML,
						next: child.nextSibling,
					});
					child.parentNode.removeChild(child);
				}
				this.aditMark = ""; // 待编辑的标点
				this.data = {}; // 位置数据以及内容
				this.banMa = []; //斑马线的数组
				this.pointList = [];
			},
		},
		watch: {},
		computed: {},
		created() {
			// console.log("mounted", this.idx);
		},
		mounted() {
			// log(this.banMa);
			document.getElementById("myBiaoZhu" + this.idx).oncontextmenu = (e) => {
				if (e && e.preventDefault) {
					//阻止默认浏览器动作(W3C)
					e.preventDefault();
				} else {
					//IE中阻止函数器默认动作的方式
					window.event.returnValue = false;
				}
				return false;
			}; //阻止冒泡行为和默认右键菜单事件
			document.getElementById("myBiaoZhu" + this.idx).ondblclick = (e) => {
				e = e || window.event;
				if (e.button !== 2) {
					//判断是否右击
					//判断是否可以进行标注
					if (this.canBiaoZhu) {
						var x = e.offsetX || e.layerX;
						var y = e.offsetY || e.layerY;
						if (x && y) this.getPoint(x, y);
					}
				}
			};
			document.getElementById("myBiaoZhu" + this.idx).ondragstart = (e) => {
				if (e && e.preventDefault) {
					//阻止默认浏览器动作(W3C)
					e.preventDefault();
				} else {
					//IE中阻止函数器默认动作的方式
					window.event.returnValue = false;
				}
				return false;
			};
		},
		beforeDestroy() {},
		destroyed() {},
	};
</script>
<style lang="scss">
	$deg: 22.5deg;

	.myBiaoZhu {
		position: relative;
		height: 100%;
		width: 100%;
		.texter {
			position: absolute;
			padding: 5px 10px;
			background: #fff;
			border: 1px solid #ccc;
			font-size: 11px;
			font-weight: 465;
			line-height: 20px;
			z-index: 99999;
			transform: translate3d(0);
		}
		.DirectionDialog {
			position: absolute;
			padding: 5px 10px;
			background: #fff;
			border: 1px solid #ccc;

			.pie {
				position: absolute;
				width: 100%;
				height: 100%;
				border-radius: 50%;
				top: -4px;
				left: 1px;
				z-index: 999;
				img {
					border: none;
				}
			}
			.closebtn {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 40px;
				height: 40px;
				font-size: 14px;
				border-radius: 50% !important;
				z-index: 9999 !important;
			}
			// @for $index from 1 through 8 {
			//   .slice-#{$index} {
			//     // transform: rotate($deg * $index) skewY(-$deg * 2 * $index);
			//   }
			//   .slice-#{$index} img {
			//     // transform: skewY($deg * 2 * $index) rotate($deg * $index);
			//   }
			// }
			.slice {
				overflow: hidden;
				position: absolute;
				display: flex;
				justify-content: space-around;
				align-items: center;
				top: 23px;
				left: 53px;

				width: 20px;
				height: 30px;
				transform-origin: -21% 100%;
			}
			img {
				width: 20px;
				height: 20px;
			}
			.slice-1 {
				transform: rotate(-22.5deg) skewY(-45deg);
			}

			.slice-1 img {
				transform: skewY(45deg) rotate(22.5deg);
			}

			.slice-2 {
				transform: rotate(22.5deg) skewY(-45deg);
			}

			.slice-2 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}

			.slice-3 {
				transform: rotate(67.5deg) skewY(-45deg);
			}

			.slice-3 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}

			.slice-4 {
				transform: rotate(112.5deg) skewY(-45deg);
			}

			.slice-4 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}

			.slice-5 {
				transform: rotate(157.5deg) skewY(-45deg);
			}

			.slice-5 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}

			.slice-6 {
				transform: rotate(202.5deg) skewY(-45deg);
			}

			.slice-6 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}

			.slice-7 {
				transform: rotate(247.5deg) skewY(-45deg);
			}

			.slice-7 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}

			.slice-8 {
				transform: rotate(292.5deg) skewY(-45deg);
			}

			.slice-8 img {
				transform: skewY(45deg) rotate(22.5deg);
				// margin-top: 50px;
				/* margin-left: 30px; */
			}
		}

		img {
			border: solid 1px #000;
			display: inline-block;
			// margin:100px 100px;
			z-index: 1;
		}
		.marker {
			position: absolute;
			cursor: pointer;
			z-index: 5;
			border-radius: 50%;
			background-size: 100% 100%;
		}
	}
</style>
